var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getKids.length > 0)?_c('list-kid',{staticClass:"kids",attrs:{"kids":_vm.getKids,"title":"Tous les enfants"}}):_vm._e(),_c('div',{staticClass:"group"},[_c('list-school-year',{staticClass:"school-years"}),_c('list-settings',{staticClass:"settings"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }